import Typography from "../Typography/Typography";
import PowerUserStyles from "./PowerUserBadgeStyles.module.scss";
const PowerUserBadge = ({ className }: any) => {
  return (
    <span className={PowerUserStyles.powerUserTag + " " + className}>
      <Typography
        style={{
          color: "white",
          fontSize: "14px",
          fontWeight: "400",
        }}
      >
        Power User
      </Typography>
    </span>
  );
};

export default PowerUserBadge;
